import { createContext, useContext, useState } from 'react';
import ConfirmationModal from '@/components/ConfirmationModal';

const ConfirmationContext = createContext();

export const useConfirmation = () => {
  return useContext(ConfirmationContext);
};

export const ConfirmationProvider = ({ children }) => {
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [confirmationDialogMessage, setConfirmationDialogMessage] = useState(
    '',
  );
  const [confirmationCallback, setConfirmationCallback] = useState(null);
  const [cancelCallback, setCancelCallback] = useState(null);
  const [commentOptions, setCommentOptions] = useState({
    showCommentField: false,
    commentLabel: undefined,
    commentPlaceholder: undefined,
    commentRequired: false,
  });

  const requestConfirmation = (
    message,
    confirmCallback,
    cancelCallback = null,
    commentConfig = null,
  ) => {
    setConfirmationDialogMessage(message);
    setConfirmationCallback(() => confirmCallback);
    setCancelCallback(() => cancelCallback);
    setCommentOptions({
      showCommentField: commentConfig?.showCommentField || false,
      commentLabel: commentConfig?.commentLabel,
      commentPlaceholder: commentConfig?.commentPlaceholder,
      commentRequired: commentConfig?.commentRequired || false,
    });
    setConfirmationDialogOpen(true);
  };

  const handleConfirmationDialogClose = (isConfirmed, comment = '') => {
    setConfirmationDialogOpen(false);
    if (isConfirmed && confirmationCallback) {
      confirmationCallback(comment);
    } else if (!isConfirmed && cancelCallback) {
      cancelCallback();
    }
    setConfirmationCallback(null);
    setCancelCallback(null);
    setCommentOptions({
      showCommentField: false,
      commentLabel: undefined,
      commentPlaceholder: undefined,
      commentRequired: false,
    });
  };

  return (
    <ConfirmationContext.Provider value={{ requestConfirmation }}>
      {children}
      <ConfirmationModal
        open={confirmationDialogOpen}
        onClose={handleConfirmationDialogClose}
        onConfirm={handleConfirmationDialogClose}
        showCommentField={commentOptions.showCommentField}
        commentLabel={commentOptions.commentLabel}
        commentPlaceholder={commentOptions.commentPlaceholder}
        commentRequired={commentOptions.commentRequired}>
        <div>{confirmationDialogMessage}</div>
      </ConfirmationModal>
    </ConfirmationContext.Provider>
  );
};
